import * as actionTypes from "../actions/actionTypes";
import {
    addRecordFail,
    addRecordStart,
    addRecordSuccess,
    clearAddRecordError,
    clearAddRecordLoading,
    clearUpdateRecordError,
    clearUpdateRecordLoading,
    updateRecordFail,
    updateRecordStart,
    updateRecord,
    updateRecordSuccess,
    addRecordToBottom,
    cancelAddRecord,
    cancelUpdateRecord,
    removeRecord,
    fetchRecordStart,
    fetchRecordSuccess,
    fetchRecordFail,
    clearRecord,
    updateSingleRecord,
    fetchListStart,
    fetchListSuccess,
    fetchListFail,
    clearList,
    clearAllLists,
    addToBottomOfLists,
    updateInLists,
    removeFromLists,
} from "../utility";

const initialState = {
    lists: {},
    record: null,
    isRecordLoading: false,
    isRecordAddLoading: null,
    isRecordUpdateLoading: null,
    recordError: null,
    addRecordError: null,
    updateRecordError: null,
    addRecordId: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_CARRIER_REJECTION_LIST_START: return fetchListStart(state, action.payload);
        case actionTypes.FETCH_CARRIER_REJECTION_LIST_SUCCESS: return fetchListSuccess(state, action.payload);
        case actionTypes.FETCH_CARRIER_REJECTION_LIST_FAIL: return fetchListFail(state, action.payload);
        case actionTypes.CLEAR_CARRIER_REJECTION_LIST: return clearList(state, action.payload);
        case actionTypes.CLEAR_CARRIER_REJECTION_LISTS: return clearAllLists(state);
        case actionTypes.ADD_TO_CARRIER_REJECTION_LIST: return addToBottomOfLists(state, action.payload);
        case actionTypes.UPDATE_IN_CARRIER_REJECTION_LIST: return updateInLists(state, action.payload);
        case actionTypes.REMOVE_FROM_CARRIER_REJECTION_LIST: return removeFromLists(state, action.payload);
        case actionTypes.FETCH_CARRIER_REJECTION_START: return fetchRecordStart(state);
        case actionTypes.FETCH_CARRIER_REJECTION_SUCCESS: return fetchRecordSuccess(state, action.payload);
        case actionTypes.FETCH_CARRIER_REJECTION_FAIL: return fetchRecordFail(state, action.payload);
        case actionTypes.CLEAR_CARRIER_REJECTION: return clearRecord(state);
        case actionTypes.ADD_CARRIER_REJECTION: return addRecordToBottom(state, action.payload);
        case actionTypes.ADD_CARRIER_REJECTION_START: return addRecordStart(state);
        case actionTypes.ADD_CARRIER_REJECTION_SUCCESS: return addRecordSuccess(state);
        case actionTypes.ADD_CARRIER_REJECTION_FAIL: return addRecordFail(state, action.payload);
        case actionTypes.ADD_CARRIER_REJECTION_LOADING_CLEAR: return clearAddRecordLoading(state);
        case actionTypes.ADD_CARRIER_REJECTION_ERROR_CLEAR: return clearAddRecordError(state);
        case actionTypes.ADD_CARRIER_REJECTION_CANCEL: return cancelAddRecord(state);
        case actionTypes.UPDATE_CARRIER_REJECTION: return updateRecord(state, action.payload);
        case actionTypes.UPDATE_SINGLE_CARRIER_REJECTION: return updateSingleRecord(state, action.payload);
        case actionTypes.UPDATE_CARRIER_REJECTION_START: return updateRecordStart(state);
        case actionTypes.UPDATE_CARRIER_REJECTION_SUCCESS: return updateRecordSuccess(state);
        case actionTypes.UPDATE_CARRIER_REJECTION_FAIL: return updateRecordFail(state, action.payload);
        case actionTypes.UPDATE_CARRIER_REJECTION_LOADING_CLEAR: return clearUpdateRecordLoading(state);
        case actionTypes.UPDATE_CARRIER_REJECTION_ERROR_CLEAR: return clearUpdateRecordError(state);
        case actionTypes.UPDATE_CARRIER_REJECTION_CANCEL: return cancelUpdateRecord(state);
        case actionTypes.REMOVE_CARRIER_REJECTION: return removeRecord(state, action.payload);
        default:
            return state;
    }
};

export default reducer;